import { LanguageSelect } from '@/shared/components';
import { useMediaQuery, useUtmTracking } from '@/shared/lib';
import { WEBSITE_URL } from '@/shared/config';
import { useSignupLanguageSwitch } from '@/features/auth-signup';

const UnauthorizedLayoutHeader = () => {
  const { language, changeLanguage, onOpenChange } = useSignupLanguageSwitch();
  const isMobile = useMediaQuery('(max-width: 40rem)');
  const { isIsolated } = useUtmTracking();

  const logo = isMobile ? (
    <img src="/assets/f2ex-logo-small.svg" alt="F2EX" />
  ) : (
    <img src="/assets/f2ex-logo.svg" alt="F2EX" className="w-[13.6rem]" />
  );

  return (
    <header className="flex sticky h-[6rem] top-0 items-center justify-between bg-background md:px-12 px-4 text-[1.4rem] z-10">
      {isIsolated ? (
        logo
      ) : (
        <a
          href={`${WEBSITE_URL}${language === 'en' ? language : ''}`}
          target="_blank"
          rel="noopener noreferrer">
          {logo}
        </a>
      )}
      <LanguageSelect
        language={language}
        changeLanguage={changeLanguage}
        onOpenChange={onOpenChange}
      />
    </header>
  );
};

export { UnauthorizedLayoutHeader };
